@value buttonContainerHeight: 63px;

.container {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 16px 0;
}

.has-images .input-container {
    border-top: none;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
